/* Text-matching primitives shared by the Careers search and the Languages search.
   Prefix matching with light typo tolerance — not autocomplete, just matching. */

// Latin-only: lowercases, strips diacritics, drops everything outside [a-z0-9].
// Fine for job titles; turns 日本語 or Ελληνικά into an empty string, so use
// normalizeUnicode() when the text may be in any script.
export function normalizeText(str = '') {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

// Same idea for any script: keeps letters and digits from every alphabet.
export function normalizeUnicode(str = '') {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function levenshtein(a, b) {
  if (a === b) return 0;
  const alen = a.length, blen = b.length;
  if (!alen) return blen;
  if (!blen) return alen;
  // use 1D DP
  const v = new Array(blen + 1);
  for (let j = 0; j <= blen; j++) v[j] = j;
  for (let i = 1; i <= alen; i++) {
    let prev = v[0];
    v[0] = i;
    const ai = a.charCodeAt(i - 1);
    for (let j = 1; j <= blen; j++) {
      const tmp = v[j];
      const cost = ai === b.charCodeAt(j - 1) ? 0 : 1;
      v[j] = Math.min(
        v[j] + 1,        // deletion
        v[j - 1] + 1,    // insertion
        prev + cost      // substitution
      );
      prev = tmp;
    }
  }
  return v[blen];
}

export function maxEdits(len) {
  if (len <= 2) return 0;
  if (len <= 4) return 1;
  if (len <= 7) return 2;
  return 3;
}

export function tokenMatchesTitleWord(qTok, tTok) {
  if (!qTok) return true;
  if (tTok === qTok) return true;
  // nice UX: allow prefix typing (not “autocomplete”, just matching)
  if (tTok.startsWith(qTok)) return true;
  // typo-tolerant: compare against prefix of title word (handles "desu" vs "design")
  const target = (tTok.length >= qTok.length) ? tTok.slice(0, qTok.length) : tTok;
  const dist = levenshtein(qTok, target);
  return dist <= maxEdits(qTok.length);
}

export function fuzzyMatchAllTokens(queryNorm, titleWords) {
  if (!queryNorm) return true;
  const qWords = queryNorm.split(' ').filter(w => w.length >= 2); // ignore 1-letter noise
  if (qWords.length === 0) return true;
  return qWords.every(qw => titleWords.some(tw => tokenMatchesTitleWord(qw, tw)));
}
